<div fxLayout="row" *ngIf="!isFakeData">
  <div fxFlex class="chat-middle-box">
    <div *ngFor="let message of communicationMessages; trackBy: trackByMethod">
      <div class="chat-list even" *ngIf="message.display.type==='even'">
        <div class="chat-message">
          <span class="chat-date">{{getDisplayDate(message.sent)}}</span>
          <div fxLayout="row" fxLayoutAlign="end">
            <div [matTooltip]="message.display.name" fxFlex="7">
              <ngx-avatar size="40" [name]="message.display.name" bgColor="#f2f4f8" fgColor="#000" initialsSize="2">
              </ngx-avatar>
            </div>
            <div class="chat-block" [ngClass]="{'template': message.display.dynamicTemplate}">
              <div fxLayout="row wrap" *ngIf="message.display.dynamicTemplate">
                <mat-accordion>
                  <mat-expansion-panel [expanded]="!message.display.isReadMore" @fadeIn
                    (afterExpand)="onReadMore(message.display)" (closed)="onReadMore(message.display)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon class="m-r-10" *ngIf="message.display.messageMedium==='LOG_CALL'">
                          {{message.display.icon}}</mat-icon>
                        <span>
                          <img class="m-0 m-r-10" *ngIf="message.display.messageMedium!=='LOG_CALL'" width="20"
                            [src]="message.display.icon">
                        </span>
                        {{message.display.dynamicTemplate.name}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div *ngIf="!message.display.isReadMore">
                      <app-template @fadeIn [htmlText]="message.display.msg"></app-template>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxLayout="row wrap" *ngIf="!message.display.dynamicTemplate">
                <mat-icon class="m-r-10" *ngIf="message.display.messageMedium==='LOG_CALL'">
                  {{message.display.icon}}</mat-icon>
                <span>
                  <img class="m-0 m-r-10" *ngIf="message.display.messageMedium!=='LOG_CALL'" width="20"
                    [src]="message.display.icon">
                </span>
                <span fxFlex class="msg m-0"
                  [ngClass]="{'message-text': message.display.isReadMore}"><span>{{message.display.msg}}</span>
                  <span *ngIf="!message.display.isReadMore" class="pointer read-more link"
                    (click)="onReadMore(message.display)">Read less</span>
                </span>
                <span *ngIf="message.display.msg.length>139&&message.display.isReadMore" class="pointer read-more link"
                  (click)="onReadMore(message.display)">Read more</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-list" *ngIf="message.display.type==='odd'">
        <div class="chat-message">
          <div fxLayout="row" fxLayoutAlign="start">
            <div fxFlex="7"></div>
            <span class="chat-date odd">{{getDisplayDate(message.sent)}}</span>
            <span class="chat-date" *ngIf="message.status">,
              {{message.status === 'completed'? 'Read' : (message.status === 'in-progress'? 'Sent' : '')}}</span>
          </div>
          <div fxLayout="row" fxLayoutAlign="start">
            <div [matTooltip]="message.display.name" fxFlex="7">
              <ngx-avatar size="40" [name]="message.display.name" bgColor="#e3f3fd" fgColor="#000" initialsSize="2">
              </ngx-avatar>
            </div>
            <div class="chat-block bg-light-info" [ngClass]="{'template': message.display.dynamicTemplate}">
              <div fxLayout="row wrap" *ngIf="message.display.dynamicTemplate">
                <mat-accordion>
                  <mat-expansion-panel class="bg-light-info" [expanded]="!message.display.isReadMore" @fadeIn
                    (afterExpand)="onReadMore(message.display)" (closed)="onReadMore(message.display)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon class="m-r-10" *ngIf="message.display.messageMedium==='LOG_CALL'">
                          {{message.display.icon}}</mat-icon>
                        <span>
                          <img class="m-0 m-r-10" *ngIf="message.display.messageMedium!=='LOG_CALL'" width="20"
                            [src]="message.display.icon">
                        </span>
                        {{message.display.dynamicTemplate.name}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div *ngIf="!message.display.isReadMore">
                      <app-template @fadeIn [htmlText]="message.display.msg"></app-template>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxLayout="row wrap" *ngIf="!message.display.dynamicTemplate">
                <mat-icon class="m-r-10" *ngIf="message.display.messageMedium==='LOG_CALL'">
                  {{message.display.icon}}</mat-icon>
                <span>
                  <img class="m-0 m-r-10" *ngIf="message.display.messageMedium!=='LOG_CALL'" width="20"
                    [src]="message.display.icon">
                </span>
                <span fxFlex class="msg m-0"
                  [ngClass]="{'message-text': message.display.isReadMore}"><span>{{message.display.msg}}</span>
                  <span *ngIf="!message.display.isReadMore" class="pointer read-more link"
                    (click)="onReadMore(message.display)">Read less</span>
                </span>
                <span *ngIf="message.display.msg.length>139&&message.display.isReadMore" class="pointer read-more link"
                  (click)="onReadMore(message.display)">Read more</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-t-20" *ngIf="communicationMessages.length>=limit||pagination_clicked_count!==0">
      <button mat-icon-button (click)="prevPage()" [disabled]="disable_prev || !(pagination_clicked_count>0)">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="page-no">Page {{pagination_clicked_count+1}}</span>
      <button mat-icon-button class="m-r-30" (click)="nextPage()" [disabled]="disable_next">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="mailbox message-widget" *ngIf="isFakeData">
  <div class="message-center">
    <a class="chat-item fake-item" fxLayoutAlign="start start" *ngFor="let message of fakeCommunicationMessages">
      <div class="m-r-15">
        <ngx-skeleton-loader count="1" appearance="circle"
          [theme]="{height: '40px', width: '40px', margin: '0px', 'border-radius': '10px'}">
        </ngx-skeleton-loader>
      </div>
      <div class="mail-content" fxFlex>
        <ngx-skeleton-loader count="1" [theme]="{height: '30px', width: '50%', margin: '-3px'}">
        </ngx-skeleton-loader>
        <div fxLayout="row wrap" class="m-t-5">
          <div fxFlex="15">
            <ngx-skeleton-loader count="1" [theme]="{height: '25px', width: '70%', margin: '-3px'}">
            </ngx-skeleton-loader>
          </div>
          <div fxFlex="15">
            <ngx-skeleton-loader count="1" [theme]="{height: '25px', width: '70%', margin: '-3px'}">
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </a>
    <div class="m-t-20">
      <div fxFlex="15">
        <ngx-skeleton-loader count="1" [theme]="{height: '30px', width: '70%', margin: '-3px'}">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>